<ui-modal
  class="organization-switch-modal"
  wrapperClass="organization-switch-modal-wrapper"
  [modalTitle]="headerTemplate"
  [closable]="closable"
  [visible]="isVisible"
  [showFooter]="false"
  [dismissMask]="closable"
  (cancel)="close.emit()"
>
  <div class="org-list-container scroll-sm flex flex-col gap-3">
    <div class="text-sm text-[#535862] leading-[20px] mt-7">
      {{ "common-messages.select-your-company" | translate }}
    </div>
    <div
      class="org-item flex justify-between items-center cursor-pointer"
      role="button"
      *ngFor="let item of orgList; trackBy: trackById"
      (click)="organizationChange.emit(item)"
    >
      <div
        class="org-description w-full flex gap-7 justify-between items-center"
        [class.w-full]="item.id !== orgId"
        [class.custom-w]="item.id === orgId"
      >
        <div class="org-title capitalize txt-elip">
          {{ item.displayName || item.name }}
        </div>
        <!--        <div class="org-size mt-2">{{ item.numOfEmp }}</div>-->
        <!--        <div class="org-id uppercase txt-elip">{{ item.extId }}</div>-->
        <svg
          width="9"
          height="17"
          viewBox="0 0 9 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.49906 15.9094C1.15613 16.2523 0.600139 16.2523 0.257213 15.9094C-0.0857126 15.5664 -0.0857123 15.0105 0.257213 14.6675L6.13437 8.79037C6.5249 8.39984 6.5249 7.76668 6.13437 7.37615L0.257214 1.499C-0.0857116 1.15607 -0.0857126 0.600079 0.257213 0.257153C0.600139 -0.0857732 1.15613 -0.0857731 1.49906 0.257153L8.61806 7.37615C9.00858 7.76668 9.00858 8.39984 8.61806 8.79037L1.49906 15.9094Z"
            fill="currentColor"
          />
        </svg>
      </div>
      <!--      <img-->
      <!--        *ngIf="item.id === orgId"-->
      <!--        src="/assets/images/green-tick.svg"-->
      <!--        class=""-->
      <!--      />-->
    </div>
  </div>
  <div class="pt-7 px-6 pb-8 flex justify-between gap-4">
    <ui-button
      size="small"
      type="default"
      addClass="!border-[#CACFD8] btn-shadow"
      innerButtonClass="min-w-[175px] !text-[var(--au-purple-600)] !px-4"
      [loading]="!!(loading$ | async)"
      [isDisabled]="!!(loading$ | async)"
      (btnClick)="logout()"
    >
      {{ "common-keywords.cancel" | translate }}
    </ui-button>
    <ui-button
      size="small"
      innerButtonClass="!px-4 min-w-[175px]"
      (btnClick)="addCompany()"
    >
      <div class="flex items-center gap-1">
        <ui-icon size="tiny" type="au-plus" class="pt-1" />
        {{
          "core.component.organization-switch-modal.action.add-new-company"
            | translate
        }}
      </div>
    </ui-button>
  </div>
</ui-modal>
<ng-template #headerTemplate>
  <img src="/assets/images/logo-dark.svg" class="logo-img min-w-[180px]" />
</ng-template>
